<template>
    <section>
        <h2 class="c-cart__title o-title-2">{{_t('Panier d’achat')}}</h2>
        <div class="c-cart__list">
            <template v-if="!isEmpty(cart.items)">
                <div class="c-cart__item" :class="{'-is-open': item.edit }" v-for="(item) in cart.items" :key="item.product_id">
                <!-- <pre>{{ item }}</pre> -->
                    <div class="c-cart__item__row">
                        <div class="c-cart__product-image__wrap" v-if="item.image && item.image!=''">
                            <div class="c-cart__product-image">
                                <img :src="item.image" :alt="item.name">
                            </div>
                        </div>
                        <div class="c-cart__product-name__wrap">
                            <div class="c-cart__item__row">
                                <div class="c-cart__product-name">
                                    <h3 class="c-cart__product__name">{{ item.name }}</h3>
                                </div>
                                <div class="c-cart__product-price">
                                    <p class="c-cart__product-price__price">{{ formatMoney(item.total) }}</p>
                                </div>
                            </div>
                            <div class="c-cart__product-description">
                                <span  v-if="item.description" class="c-cart__product-description" v-html="item.description"></span>

                                <div v-if="!item.priceIsValid" class="-price-error">
                                    {{ _t('* Attention! Le prix a changé depuis que vous avez ajouté ce produit à votre panier. Vous devez le supprimer de votre panier et le réajouter pour pouvoir commander.') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c-cart__item__row -controls">
                        <div class="c-cart__item__group">
                            <div class="c-cart__product-quantity">
                                <input type="number" v-model="item.quantity" @change="updateQty($event.target.value, item)" @keyup.enter="updateQty($event.target.value, item)">
                            </div>
                            <button class="c-cart__product-btn-delete" @click="deleteProduct(item.product_id)">
                                <span class="sr-only">{{_t('Supprimer')}}</span>
                                <svg aria-hidden="true" focusable="false" class="o-ico -icon-cart">
                                    <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#trash"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="c-cart__item">
                    <div class="c-cart__item__row -controls">
                        {{ _t('Sous-total') }} : 
                        <strong style="margin-left: 16px;">
                            {{ formatMoney(cart.subtotal) }}
                        </strong>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="c-cart__empty">
                    <h3>{{_t('Votre panier est vide')}}</h3>
                    <p>{{_t("Vous n'avez pas encore d'articles dans votre panier.")}}</p>
                </div>
            </template>
        </div>
        <div v-if="cart.items && cart.items.length > 0" class="c-cart__pay-button">
            <button class="o-button o-button-cart" target="_blank" aria-label="{{_t('Commander')}}" @click="checkout()">
                <span class="o-button__text">{{ _t('Commander') }}</span>
                <svg aria-hidden="true" focusable="false" class="o-ico -icon-arrow-full-right">
                    <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#pay"></use>
                </svg>  
            </button>
        </div>
        <!-- <pre>{{ cart.items }}</pre> -->
    </section>
</template>
<script>
//Import axios
import axios from 'axios'

export default {
    name: 'ProductCart',
    data() {
        return {
            cart: {},
            token: null,
            showTaxes: window.ajax_var.showTaxes,
            groups: [],
            error: null,
            pages: window.ajax_var.pages
        }
    },
    methods: {
        getCart() {
            //Fetch cart from API
            if (this.$store.state.token) {
                this.token = this.$store.state.token
            }
            let params = {
                token: this.token,
                _wpnonce: window.ajax_var.nonce,
                validateitems: true,
                rand: Math.floor(Math.random() * 1000000),
            }
            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce

            axios.get('/wp-json/stereostore/v1/cart', { params })
                .then(response => {
                    this.cart = response.data.data
                    this.token = response.data.data.token
                    try{
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'view_cart',
                            'ecommerce': {
                                'currency': window.ajax_var.currency,
                                'items': this.cart.items.map(item => {
                                    return {
                                        'id': item.product_id,
                                        'name': item.name,
                                        'price': item.price,
                                        'quantity': item.quantity
                                    }
                                })
                            }
                        });
                    }catch(e){
                        console.log(e)
                    }
                    if(this.cart.lock){
                        this.cart.lock = false
                        this.updateDistantCart(this.token)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        updateCart(token) {
            this.$store.commit('updateToken', token)
        },
        updateQty(quantity, item) {
            // Prevent quantity from going below 1
            if (quantity < 1) {
                item.quantity = 1;
            } else {
                item.quantity = quantity;
            }

            // Update the item's total price based on quantity and price
            item.total = item.price * item.quantity;

            // Send the updated cart to the server
            this.updateDistantCart();
        },
        async updateDistantCart() {
            let params = {
                cart: this.cart,
                token: this.token,
                _wpnonce: window.ajax_var.nonce
            }
            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            return axios.put('/wp-json/stereostore/v1/cart', params)
                .then(response => {
                    this.cart = response.data.data
                    this.token = response.data.data.token
                    this.updateCart(this.token)

                    //Parse metadata
                    for (let i = 0; i < this.cart.items.length; i++) {
                        //Check if string or object
                        if (typeof this.cart.items[i].metadata === 'string') {
                            this.cart.items[i].metadata = JSON.parse(this.cart.items[i].metadata)
                        }
                    }
                    if (document.querySelector('.js-cart-count')) {
                        document.querySelector('.js-cart-count').textContent = (this.cart.items.length>0) ? this.cart.items.length : ''
                    }
                    return response
                })
                .catch(error => {
                    console.log(error)
                })
        },
        isEmpty(array) {
            return !Array.isArray(array) || !array.length
        },
        formatMoney(value) {
            let language = window.ajax_var.currentLang;
            let currency = window.ajax_var.currency;
            var formatter = new Intl.NumberFormat(language, {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'narrowSymbol'
            });
            return formatter.format(value);
        },
        deleteProduct(id) {
            if (!confirm(this._t('Voulez-vous vraiment supprimer ce produit ?'))) {
                return;
            }
            try{
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'remove_from_cart',
                    'ecommerce': {
                        'currency': window.ajax_var.currency,
                        'items': this.cart.items.filter(item => item.product_id === id).map(item => {
                            return {
                                'id': item.product_id,
                                'name': item.name,
                                'price': item.price,
                                'quantity': item.quantity,
                                'variant': item.sku
                            }
                        })
                    }
                });
            }catch(e){
                console.log(e)
            }
            this.cart.items = this.cart.items.filter(item => item.product_id !== id)
            this.updateDistantCart()
        },
        async checkout() {
            this.cart.lock = true;
            let response = await this.updateDistantCart()
            if(response.data.success) location.href = this.pages.checkout
            else {
                this.error = response.data.message
                this.cart.lock = false
            }
        },
        calculateTaxes() {
            let taxes = this.cart.taxes
            let total = 0
            for (let i = 0; i < taxes.length; i++) {
                total += taxes[i].amount
            }
            return this.formatMoney(total)
        },
    },
    mounted() {
        this.getCart()
// alert('ici')
        // console.log(this._t)
        // this._t('ddf')
    }
}
</script>
